import { all } from 'redux-saga/effects';
import getUserProfile from './profile';

export const authSagas = function* root() {
  yield all([getUserProfile()]);
};
